import { render, staticRenderFns } from "./ProcessIndexConfig.vue?vue&type=template&id=6b1cf9e7&scoped=true"
import script from "./ProcessIndexConfig.vue?vue&type=script&lang=js"
export * from "./ProcessIndexConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1cf9e7",
  null
  
)

export default component.exports